export default __webpack_public_path__ + "static/media/redcompra.ce10f131.png";